import { render, staticRenderFns } from "./ModalItemInventario.vue?vue&type=template&id=1891406b&"
import script from "./ModalItemInventario.vue?vue&type=script&lang=js&"
export * from "./ModalItemInventario.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports